import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const EApplicationSettingsComponent = ({ selectEApplicationSettings, handleInnerFormChange }: any) => {

    return (
        <>

            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Enabled AutoPopulate Entry for Purchase"
                            name="IsEnabledAutopopulateEntryforPurchase"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEnabledAutopopulateEntryforPurchase',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEnabledAutopopulateEntryforPurchase}
                        />
                        <InputContainer
                            label="Enabled AutoPopulate Entry for Sales"
                            name="IsEnabledAutopopulateEntryforSales"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEnabledAutopopulateEntryforSales',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEnabledAutopopulateEntryforSales}
                        />
                        <InputContainer
                            label="Enabled AutoPopulate Ledger for Customer"
                            name="IsEnabledAutopopulateLedgerforCustomer"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEnabledAutopopulateLedgerforCustomer',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEnabledAutopopulateLedgerforCustomer}
                        />
                        <InputContainer
                            label="Enabled AutoPopulate Ledger for Supplier"
                            name="IsEnabledAutopopulateLedgerforSupplier"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEnabledAutopopulateLedgerforSupplier',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEnabledAutopopulateLedgerforSupplier}
                        />
                        <InputContainer
                            label="Enabled AutoPopulate Ledger for Vendor"
                            name="IsEnabledAutopopulateLedgerforVendor"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEnabledAutopopulateLedgerforVendor',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEnabledAutopopulateLedgerforVendor}
                        />
                        <InputContainer
                            label="Overwrite Voucher During Import"
                            name="IsOverwriteVoucherDuringImport"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsOverwriteVoucherDuringImport',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsOverwriteVoucherDuringImport}
                        />
                        <InputContainer
                            label="Ignore Error During Import"
                            name="IsIgnoreErrorDuringImport"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsIgnoreErrorDuringImport',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsIgnoreErrorDuringImport}
                        />
                        <InputContainer
                            label="Enabled Warning Negative Balance"
                            name="IsEnabledWarningNegativeBalance"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEnabledWarningNegativeBalance',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEnabledWarningNegativeBalance}
                        />
                        <InputContainer
                            label="Edit Enabledin For Manual Account Transaction"
                            name="IsEditEnabledinForManualAccountTransaction"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEditEnabledinForManualAccountTransaction',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEditEnabledinForManualAccountTransaction}
                        />
                        <InputContainer
                            label="Edit Enabledin For AutoPopulate Account Transaction"
                            name="IsEditEnabledinForAutopopulateAccountTransaction"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsEditEnabledinForAutopopulateAccountTransaction',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsEditEnabledinForAutopopulateAccountTransaction}
                        />
                        <InputContainer
                            label="Remove Date on Altering Reconcile"
                            name="IsRemoveDateonAlteringReconcile"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsRemoveDateonAlteringReconcile',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsRemoveDateonAlteringReconcile}
                        />
                        <InputContainer
                            label="Supplier Ledger Enabled"
                            name="IsSupplierLedgerEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'AccountSettings.IsSupplierLedgerEnabled',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.AccountSettings?.IsSupplierLedgerEnabled}
                        />
                        <InputContainer
                            label="Voucher Number Prefix"
                            name="VoucherNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'AccountSettings.VoucherNumberPrefix',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="text"
                            value={selectEApplicationSettings?.AccountSettings?.VoucherNumberPrefix}
                        />
                        <InputContainer
                            label="Receipt Number Prefix"
                            name="ReceiptNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'AccountSettings.ReceiptNumberPrefix',
                                    selectEApplicationSettings?.AccountSettings
                                )
                            }}
                            type="text"
                            value={selectEApplicationSettings?.AccountSettings?.ReceiptNumberPrefix}
                        />
                    </div>
                }
                expandedPanel="Account Settings"
                headerTitle="Account Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Payroll Enabled"
                            name="IsPayrollEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'HRMSSettings.IsPayrollEnabled',
                                    selectEApplicationSettings?.HRMSSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.HRMSSettings?.IsPayrollEnabled}
                        />
                        <InputContainer
                            label="Employee Benefits Enabled"
                            name="IsEmployeeBenefitsEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'PurchaseRequestSettings.IsEmployeeBenefitsEnabled',
                                    selectEApplicationSettings?.PurchaseRequestSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.PurchaseRequestSettings?.IsEmployeeBenefitsEnabled}
                        />
                    </div>
                }
                expandedPanel="HRMS Settings"
                headerTitle="HRMS Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Digital CheckIn Enabled"
                            name="IsDigitalCheckInEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DigitalCheckInSettings.IsDigitalCheckInEnabled',
                                    selectEApplicationSettings?.DigitalCheckInSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.DigitalCheckInSettings?.IsDigitalCheckInEnabled}
                        />
                    </div>
                }
                expandedPanel="DigitalCheckIn Settings"
                headerTitle="DigitalCheckIn Settings"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Include Terms Library In Contract Enabled"
                            name="IsIncludeTermsLibraryInContractEnabled"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContractSettings.IsIncludeTermsLibraryInContractEnabled',
                                    selectEApplicationSettings?.ContractSettings
                                )
                            }}
                            type="checkbox"
                            value={selectEApplicationSettings?.ContractSettings?.IsIncludeTermsLibraryInContractEnabled}
                        />
                    </div>
                }
                expandedPanel="Contract Settings"
                headerTitle="Contract Settings"
            />
        </>
    )
}
export default EApplicationSettingsComponent;
